/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_ExcludeInputs */

const en_us2_exercise_exclude = /** @type {(inputs: Exercise_ExcludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never suggest`)
};

const pt_br2_exercise_exclude = /** @type {(inputs: Exercise_ExcludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nunca sugerir`)
};

const es_419_exercise_exclude = /** @type {(inputs: Exercise_ExcludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sugerir nunca`)
};

const pt_pt2_exercise_exclude = /** @type {(inputs: Exercise_ExcludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nunca sugerir`)
};

const fr_fr2_exercise_exclude = /** @type {(inputs: Exercise_ExcludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne plus suggérer`)
};

const de_de2_exercise_exclude = /** @type {(inputs: Exercise_ExcludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie vorschlagen`)
};

const it_it2_exercise_exclude = /** @type {(inputs: Exercise_ExcludeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non suggerire mai`)
};

/**
* | output |
* | --- |
* | "Never suggest" |
*
* @param {Exercise_ExcludeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_exclude = /** @type {((inputs?: Exercise_ExcludeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_ExcludeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_exclude(inputs)
	if (locale === "es-419") return es_419_exercise_exclude(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_exclude(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_exclude(inputs)
	if (locale === "de-DE") return de_de2_exercise_exclude(inputs)
	if (locale === "it-IT") return it_it2_exercise_exclude(inputs)
	return en_us2_exercise_exclude(inputs)
});
export { exercise_exclude as "exercise.exclude" }